import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

export const CONCEPT_DICTIONARY = {
  'load-unload': {
    canonicalName: 'Load / Unload',
    aliases: [
      'load / unload',
      ' load / unload',
      'load/unload',
      'loading / unloading',
      'load unload',
      'loading unloading',
      'load and unload',
      'load/ unload',
      'load /unload',
    ],
    description: 'Loading / Unloading parts on machine',
  },
  'new-setup': {
    canonicalName: 'New Setup',
    aliases: ['new setup', 'new setting p', 'new setting', 'setup change', 'setting', 'new setup change', 'setup'],
    description: 'Component changeover / new machine setting',
  },
  'machine-breakdown': {
    canonicalName: 'Machine Breakdown',
    aliases: [
      'm/c b/d',
      'machine break down',
      'machine breakdown',
      'mc bd',
      'mc breakdown',
      'mc b d',
      'breakdown',
      'm/c breakdown',
      'machine b/d',
    ],
    description: 'Mechanical or electrical machine breakdown',
  },
  'bc-correction': {
    canonicalName: 'Blue Card Correction',
    aliases: ['b/c correction', 'blue card correction', 'bc correction', 'bluecard correction', 'blue card corr', 'b/c corr'],
    description: 'Blue card dimension/process correction',
  },
  'wf-bc': {
    canonicalName: 'Waiting For Blue Card',
    aliases: [
      'w/f b/c',
      'waiting for bluecard p',
      'waiting for blue card',
      'wf bc',
      'wf blue card',
      'waiting for bluecard',
      'waiting blue card',
      'w/f blue card',
    ],
    description: 'Waiting for blue card inspection/approval',
  },
  'tc-correction': {
    canonicalName: 'Tool Change Correction',
    aliases: ['t/c correction', 'tool change p', 'tool change correction', 'tc correction', 'tool change', 'tool change p '],
    description: 'Correction after tool change',
  },
  'tc-insp': {
    canonicalName: 'Tool Change Inspection',
    aliases: ['t/c insp', 'tool change inspection p', 'tool change inspection', 'tc insp', 'tc inspection', 't/c inspection'],
    description: 'First piece inspection after tool change',
  },
  '1man-2mc': {
    canonicalName: '1 Operator 2 Machines',
    aliases: ['1 man 2 m/c run', 'one operator two machines', '1 man 2 mc run', '1 man 2 mc', '1 operator 2 machines', '1man 2mc', '1 man 2 mc '],
    description: 'Single operator running multiple machines simultaneously',
  },
  'power-failure': {
    canonicalName: 'Power Failure',
    aliases: ['power failure', 'power_failure', 'power cut', 'eb power failure', 'eb failure'],
    description: 'Electrical power failure / grid outage',
  },
  'air-issues': {
    canonicalName: 'Air Issues / Low Air',
    aliases: ['low air ', 'low air', 'air issues', 'low air pressure', 'pneumatic issue', 'low air pressure issue', 'air issue'],
    description: 'Low air pressure or pneumatic system issue',
  },
  'operator-issues': {
    canonicalName: 'Operator Leave / Issues',
    aliases: ['operator leave', 'operator issues', 'operator not available', 'manpower shortage', 'operator absent', 'operator issue'],
    description: 'Operator absence, leave, or shortage',
  },
  'tool-issue': {
    canonicalName: 'Tool Issues',
    aliases: ['tool issue', 'tool issues', 'insert worn out', 'tool breakage', 'tool wear', 'tool change issue'],
    description: 'Tooling wear, breakage, or insert problem',
  },
  'qc-issues': {
    canonicalName: 'Quality Issues',
    aliases: ['q/c issues', 'quality issues', 'qc issues', 'rejection issue', 'qc issue', 'q/c issue'],
    description: 'Part dimension out of tolerance or quality rejection',
  },
  'gauge-issues': {
    canonicalName: 'Gauge Issues',
    aliases: ['gauge issues', 'gauges instruments issues', 'gauge issue', 'instrument issue', 'gauges issues', 'instruments issues'],
    description: 'Measuring instrument, bore gauge, or micrometer problem',
  },
  'fixture-issues': {
    canonicalName: 'Fixture Issues',
    aliases: ['fixture issues', 'fixture_issues', 'fixture problem', 'clamping issue', 'fixture issue', 'fixture clamping'],
    description: 'Fixture alignment, clamping, or hydraulic problem',
  },
  'wf-doc': {
    canonicalName: 'Waiting For Documents',
    aliases: ['w/f documents', 'document issue', 'wf documents', 'drawing issue', 'w/f doc', 'waiting for doc', 'waiting for documents'],
    description: 'Waiting for drawing, route card, or work order',
  },
  'wf-rm': {
    canonicalName: 'Waiting For Raw Material',
    aliases: [
      'w/f r/m',
      'material issues',
      'wf rm',
      'raw material shortage',
      'r/m not feed',
      'rm not feed',
      'waiting for raw material',
      'w/f rm',
      'waiting for r/m',
    ],
    description: 'Waiting for raw material or forging/casting supply',
  },
  'wf-nc': {
    canonicalName: 'NC Program Issues',
    aliases: ['w/f nc prgm', 'nc program issues', 'wf nc prgm', 'cnc program issue', 'nc program', 'w/f nc program', 'waiting for nc prgm'],
    description: 'Waiting for NC program transfer or program modification',
  },
  'burr-cleaning': {
    canonicalName: 'Burr Cleaning',
    aliases: ['burr cleaning', 'burr cleaning_mc cleaning', 'burr cleaning mc cleaning', 'deburring', 'mc cleaning', 'burr clean', 'machine cleaning'],
    description: 'Chip removal, deburring, and machine cleaning',
  },
  'coolant': {
    canonicalName: 'Coolant Filling / Issues',
    aliases: ['coolant filling', 'coolant problems', 'coolant top up', 'low coolant', 'coolant issue', 'coolant problem'],
    description: 'Coolant top-up, concentration check, or coolant pump issue',
  },
  'meeting': {
    canonicalName: 'Meeting',
    aliases: ['meeting', 'meeting_', 'toolbox meeting', 'shift meeting', 'daily meeting'],
    description: 'Shift handover or department meeting',
  },
  'preventive-corr': {
    canonicalName: 'Preventive Correction',
    aliases: ['preventive correction', 'preventive corrections p', 'preventive corrections', 'pm correction', 'preventive corr'],
    description: 'Preventive inspection and corrective action',
  },
  'preventive-maint': {
    canonicalName: 'Preventive Maintenance',
    aliases: ['preventive maintanance', 'preventive maintenance', 'pm activity', 'pm maintenance'],
    description: 'Scheduled preventive maintenance on machine',
  },
  'lunch': {
    canonicalName: 'Lunch',
    aliases: ['lunch', 'lunch break'],
    description: 'Planned lunch break',
  },
  'tea-break': {
    canonicalName: 'Tea Break',
    aliases: ['tea break', 'tea', 'tea/coffee', 'tea coffee'],
    description: 'Planned tea break',
  },
  'breakfast': {
    canonicalName: 'Breakfast',
    aliases: ['break fast', 'breakfast', 'tiffin'],
    description: 'Planned breakfast break',
  },
  'dinner': {
    canonicalName: 'Dinner',
    aliases: ['dinner', 'dinner break'],
    description: 'Planned dinner break',
  },
  'night-snack': {
    canonicalName: 'Night Snack',
    aliases: ['night snack', 'snack break', 'midnight snack'],
    description: 'Planned midnight snack break',
  },
  'fixture-work': {
    canonicalName: 'Fixture Work',
    aliases: ['fixture work', 'fixture maintenance', 'fixture repair'],
    description: 'Planned fixture setup or maintenance',
  },
  'fai': {
    canonicalName: 'First Article Inspection (FAI)',
    aliases: ['fai', 'dfai', 'first piece inspection', 'first article inspection'],
    description: 'First article inspection approval',
  },
  'ci': {
    canonicalName: 'Continuous Improvement (CI)',
    aliases: ['ci', 'kaizen', '5s', 'continuous improvement'],
    description: 'Continuous improvement / 5S activities',
  },
  'rm-feed': {
    canonicalName: 'Raw Material Not Feed',
    aliases: ['r/m not feed', 'rm not feed', 'bar feeder issue', 'raw material not feed'],
    description: 'Raw material feeder or bar loader issue',
  },
  'touch-screen': {
    canonicalName: 'Display Touch Not Working',
    aliases: ['display touch not work', 'display touch not working', 'touch screen issue', 'hmi issue'],
    description: 'HMI / Touchscreen display malfunction',
  },
  'feature-update': {
    canonicalName: 'Feature Update - Yantra',
    aliases: ['feature update - yantra', 'yantra update', 'software update'],
    description: 'System software / IoT feature update',
  },
  'planning-issues': {
    canonicalName: 'Planning Issues',
    aliases: ['planning issues', 'production planning', 'scheduling issue'],
    description: 'Production planning or scheduling delay',
  },
  'food-cab': {
    canonicalName: 'Food and Cab Delay',
    aliases: ['food and cab delay', 'transport delay', 'canteen delay'],
    description: 'Transport cab delay or canteen delay',
  },
  'hr-related': {
    canonicalName: 'HR Related',
    aliases: ['hr related', 'training', 'hr activity'],
    description: 'HR training, interview, or townhall',
  },
  'process-issue': {
    canonicalName: 'Process Issue',
    aliases: ['process issue', 'process issues', 'machining process'],
    description: 'Process parameter or cutting condition issue',
  },
  'others': {
    canonicalName: 'Others',
    aliases: ['others', 'other reasons', 'miscellaneous', 'other'],
    description: 'Other unclassified downtime',
  },
};

/**
 * Helper to normalize string for alias matching (lowercase, collapse whitespace, strip punctuation variants)
 */
export function cleanKey(str) {
  return (str || '')
    .trim()
    .toLowerCase()
    .replace(/[/\\_.\-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Merge raw downtime telemetry reasons to the expected canonical reasons for the selected plant(s).
 * - Keyed by conceptKey so duplicate reason variants (e.g. `Load / unload` vs `load / unload`)
 *   can NEVER appear as multiple bars.
 * - Reasons not in that plant's Master Data are rolled into "Others".
 */
export function mergeReasonsForPlant(rawList = [], selectedPlantCodes = [], masterReasons = []) {
  const selectedCodes = (selectedPlantCodes || []).map((c) => String(c).trim().toLowerCase()).filter(Boolean);

  // Master reasons registered specifically for the selected plant(s)
  const plantMaster = selectedCodes.length > 0
    ? (masterReasons || []).filter((m) => {
        const code = String(m?.plant_code ?? m?.plantCode ?? m?.plant ?? '').trim().toLowerCase();
        return selectedCodes.includes(code);
      })
    : (masterReasons || []);

  // 1. Build lookup from clean string -> conceptKey
  const cleanToConceptKey = new Map();
  // And lookup from conceptKey -> targetDisplayName
  const conceptTargetName = new Map();

  for (const [cKey, def] of Object.entries(CONCEPT_DICTIONARY)) {
    cleanToConceptKey.set(cleanKey(def.canonicalName), cKey);
    for (const alias of def.aliases) {
      cleanToConceptKey.set(cleanKey(alias), cKey);
    }
    conceptTargetName.set(cKey, def.canonicalName);
  }

  // 2. Override concept target names with this plant's registered Master Data names
  for (const m of plantMaster) {
    const rawTarget = m?.reason || m?.reason_name || m?.name;
    if (!rawTarget) continue;
    const targetClean = cleanKey(rawTarget);

    const matchedConceptKey = cleanToConceptKey.get(targetClean);
    if (matchedConceptKey) {
      // Use this plant's registered reason name (e.g. "load / unload" on G1)
      conceptTargetName.set(matchedConceptKey, rawTarget);
    } else {
      // Custom plant reason
      const customKey = `custom-${targetClean}`;
      cleanToConceptKey.set(targetClean, customKey);
      conceptTargetName.set(customKey, rawTarget);
    }
  }

  // 3. Aggregate raw telemetry reasons by conceptKey
  const mergedMap = new Map();
  let unassignedOthersSecs = 0;
  const unassignedReasons = [];

  for (const item of rawList || []) {
    const rawName = (item?.name || '').trim();
    const rawSecs = item?.total_idle_duration || 0;
    if (!rawName || rawSecs <= 0) continue;

    const clean = cleanKey(rawName);

    if (clean === 'others' || clean === 'other') {
      unassignedOthersSecs += rawSecs;
      continue;
    }

    // Find conceptKey for this telemetry string
    let cKey = cleanToConceptKey.get(clean);

    // Fallback: check if clean matches any known alias
    if (!cKey) {
      for (const [key, def] of Object.entries(CONCEPT_DICTIONARY)) {
        if (def.aliases.some((a) => cleanKey(a) === clean)) {
          cKey = key;
          break;
        }
      }
    }

    if (cKey) {
      const targetName = conceptTargetName.get(cKey) || CONCEPT_DICTIONARY[cKey]?.canonicalName || rawName;

      if (!mergedMap.has(cKey)) {
        mergedMap.set(cKey, {
          conceptKey: cKey,
          name: targetName,
          total_duration_seconds: 0,
          rawAliases: [],
          isPlantRegistered: true,
        });
      }
      const existing = mergedMap.get(cKey);
      existing.total_duration_seconds += rawSecs;
      if (!existing.rawAliases.includes(rawName)) {
        existing.rawAliases.push(rawName);
      }
    } else {
      // Reason is NOT registered in this plant's Master Data -> roll into Others!
      unassignedOthersSecs += rawSecs;
      if (!unassignedReasons.includes(rawName)) {
        unassignedReasons.push(rawName);
      }
    }
  }

  const mergedReasons = Array.from(mergedMap.values()).sort(
    (a, b) => b.total_duration_seconds - a.total_duration_seconds
  );

  return {
    mergedReasons,
    unassignedOthersSecs,
    unassignedReasons,
  };
}

/**
 * Merge multiple breakdown query results by period_start and sum durations.
 */
export function mergeBreakdownSeries(breakdownResponses = [], period = 'day') {
  const periodMap = new Map();

  for (const res of breakdownResponses) {
    for (const row of res?.data || []) {
      const p = row?.period_start;
      if (!p) continue;
      const dur = row?.total_idle_duration || 0;
      const d = dayjs(p);
      let label = p;
      if (d.isValid()) {
        if (period === 'week') label = `FW-${String(d.isoWeek()).padStart(2, '0')}`;
        else if (period === 'month') label = d.format('MMM YYYY');
        else if (period === 'quarter') label = `Q${Math.ceil((d.month() + 1) / 3)} ${d.format('YYYY')}`;
        else label = d.format('DD-MM-YYYY');
      }
      const ts = d.isValid() ? d.valueOf() : (new Date(p).getTime() || 0);

      if (!periodMap.has(label)) {
        periodMap.set(label, { timestamp: ts, duration_seconds: 0, label });
      }
      periodMap.get(label).duration_seconds += dur;
    }
  }

  // Sort chronologically by timestamp
  return Array.from(periodMap.values())
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((item) => ({
      period: item.label,
      duration_seconds: item.duration_seconds,
    }));
}
